module.exports = __webpack_public_path__ + "static/media/fi-rr-cross-small.a010efc4.svg";